import * as React from 'react';
import Glow from '@/core/design-system/Glow';
import Header from './components/Header';
import { cn } from '@/core/utils/cn';

type MainLayoutProps = {
  children: React.ReactNode;
  className?: string;
  childrenClassName?: string;
  displayGlow?: boolean;
  displayHeader?: boolean;
};

const MainLayout = ({
  children,
  className,
  childrenClassName,
  displayGlow = true,
  displayHeader = true,
}: MainLayoutProps) => (
  <div className="min-h-screen bg-main flex flex-col relative">
    {displayGlow ? <Glow /> : null}
    {displayHeader ? <Header /> : null}
    <div className={cn('flex justify-center grow pb-10 z-10', className)}>
      <div className={cn('w-full', childrenClassName)}>{children}</div>
    </div>
  </div>
);

export default MainLayout;
